import { Checkmark, UserMultiple } from '@carbon/icons-react';
import { defineMessages, useIntl } from 'react-intl';

import InfoCard from 'Components/Common/InfoCard/InfoCard';
import styles from './EntitiesInfoCard.module.scss';

const PeopleIcon = () => (
    <div className={styles.iconWrapper}>
        <UserMultiple />
    </div>
);

const EntitiesInfoCard = () => {
    const intl = useIntl();

    return (
        <InfoCard
            id="all-entities-info"
            className={styles.card}
            isHorizontal
            isClosable
            illustration={<PeopleIcon />}
            title={intl.formatMessage(messages.title)}
            description={intl.formatMessage(messages.description)}
            items={[
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.mainGroupTitle),
                    description: intl.formatMessage(messages.mainGroupDescription),
                },
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.additionalGroupsTitle),
                    description: intl.formatMessage(messages.additionalGroupsDescription),
                },
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.subscriptionLimitTitle),
                    description: intl.formatMessage(messages.subscriptionLimitDescription),
                },
            ]}
        />
    );
};

const messages = defineMessages({
    title: {
        id: 'src.Screens.Dashboard.AllEntities.EntitiesInfoCard.title',
        defaultMessage: 'Jak to działa?',
    },
    description: {
        id: 'src.Screens.Dashboard.AllEntities.EntitiesInfoCard.description',
        defaultMessage: 'Każda grupa ma swój unikalny kod dołączenia. Parafianie mogą dołączyć do grupy, wpisując kod w aplikacji.',
    },
    mainGroupTitle: {
        id: 'src.Screens.Dashboard.AllEntities.EntitiesInfoCard.mainGroupTitle',
        defaultMessage: '"Parafia" to grupa główna',
    },
    mainGroupDescription: {
        id: 'src.Screens.Dashboard.AllEntities.EntitiesInfoCard.mainGroupDescription',
        defaultMessage: 'Każdy parafianin należy do niej domyślnie i może dołączyć kodem lub wybierając parafię z listy w aplikacji.',
    },
    additionalGroupsTitle: {
        id: 'src.Screens.Dashboard.AllEntities.EntitiesInfoCard.additionalGroupsTitle',
        defaultMessage: 'Grupy dodatkowe',
    },
    additionalGroupsDescription: {
        id: 'src.Screens.Dashboard.AllEntities.EntitiesInfoCard.additionalGroupsDescription',
        defaultMessage: 'Służą do różnych wspólnot i działań parafii, np. grupa "Lektorzy" organizowałaby harmonogram ich działań.',
    },
    subscriptionLimitTitle: {
        id: 'src.Screens.Dashboard.AllEntities.EntitiesInfoCard.subscriptionLimitTitle',
        defaultMessage: 'Limit zależy od subskrypcji',
    },
    subscriptionLimitDescription: {
        id: 'src.Screens.Dashboard.AllEntities.EntitiesInfoCard.subscriptionLimitDescription',
        defaultMessage: 'Ilość grup, które możesz stworzyć, zależy od Twojej subskrypcji.',
    },
});

export default EntitiesInfoCard;
